import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();

// Polyfill for fetch
import 'whatwg-fetch'

import 'bootstrap/dist/css/bootstrap.css';
import './bootstrap-theme.css';
import './index.css';



ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js